import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyDy-5Ej8R2fhjM3SlPBOlHxUbTky884TNU",
  authDomain: "uniaoferr-35584.firebaseapp.com",
  projectId: "uniaoferr-35584",
  storageBucket: "uniaoferr-35584.firebasestorage.app",
  messagingSenderId: "706283250290",
  appId: "1:706283250290:web:84e8b19a1efd825e2858eb",
  measurementId: "G-RC5CSW4CC0"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

export const auth = getAuth(app);
export default app;
